import { Text as Paragraph, Title } from '../Typography';
import { Image } from './components/Image';
import { SearchResults } from './components/SearchResult';

export interface IAssetComponents {
  url: string;
  altText: string;
}

export interface IComponentData {
  subHeading?: string;
  heading?: string;
  assetsComponents?: {
    asset?: IAssetComponents[];
  }[];
}

export interface IHits {
  prod_recipe_uk?: any;
  prod_tips_and_tricks_uk?: any;
  query: string;
}

export interface IPopularSearchComponent {
  componentData?: IComponentData;
  hits?: IHits[];
  trackingEvents?: {
    clickPopularSearch?: (item: any, index: number) => void;
  };
  onItemClick?: () => void;
}

export const PopularSearch = ({
  componentData,
  hits,
  trackingEvents,
  onItemClick,
}: IPopularSearchComponent) => {
  const topRightImage = componentData?.assetsComponents?.[0]?.asset?.[0]?.url;
  const bottomRightImage = componentData?.assetsComponents?.[1]?.asset?.[0]?.url;
  const bottomLeftImage = componentData?.assetsComponents?.[2]?.asset?.[0]?.url;
  return (
    <section className="relative w-full p-0 m-0 md:pt-20 sm:pt:10">
      <svg
        className="absolute left-0 sm:-mt-16 md:-mt-4"
        width="100%"
        height="80"
        viewBox="0 0 1290 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 168C7.16344 168 0 160.837 0 152V43.5099C0 43.5099 296.521 -3.02334e-05 647.688 0C998.854 3.02336e-05 1290 43.51 1290 43.51V152C1290 160.837 1282.84 168 1274 168H16Z"
          fill="#F4F5F4"
        />
      </svg>
      <div className="mt-16 bg-bg-light-gray relative md:pb-80 sm:pb-32">
        <Image type="topRight" src={topRightImage} />
        <div className="relative text-center md:mb-30 sm:mb-50 pt-10">
          <Paragraph className="mb-2.5" tag="p" type="lead">
            {componentData?.subHeading}
          </Paragraph>
          <Title className="mb-10" tag="h2" type="md">
            {componentData?.heading}
          </Title>
        </div>
        <SearchResults
          hits={hits}
          clickPopularSearch={trackingEvents?.clickPopularSearch}
          onItemClick={onItemClick}
        />
        <Image type="bottomRight" src={bottomRightImage} />
        <Image type="bottomLeft" src={bottomLeftImage} />
      </div>
    </section>
  );
};
